import React from 'react';
import { Typography } from 'antd';
import { getCommonEntityStatusText } from 'entities/Bitecoin/Bitecoin.helper';
import { ECommonEntityStatus } from 'entities/Bitecoin/Bitecoin.models';

export interface ICategoryModel extends Components.Schemas.CategoryDto {
  categoryName?: string;
}
export interface ICategoryCollection extends Components.Schemas.CategoryCollectionDto {}
export interface ICategoryUpdateData extends Components.Schemas.CategoryUpdateDto {
  id: string;
}
export interface ICategoryCreateData extends Components.Schemas.CategoryCreateDto {}
export interface ICategoryCollectionFilter extends Paths.CategoryControllerGetList.QueryParameters {}

export enum ECategorySuccessMessage {
  Delete = 'Category has been successfully deleted',
  Create = 'Category has been successfully created',
  Edit = 'Category has been successfully edited',
}

export const categoryTableConfig = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    ellipsis: true,
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    render: (value: string) => (
      <Typography.Paragraph title={value}>
        {' '}
        {getCommonEntityStatusText(value as ECommonEntityStatus)}{' '}
      </Typography.Paragraph>
    ),
  },
];

export enum ECategoryType {
  IsAddOns = 'isAddOns',
  EnableAddOns = 'isAddOnsEnable',
  DisableAddOns = 'isAddOnsDisable',
}
export enum ECategoryTypeText {
  IsAddOns = 'Make items of this category add-ons',
  EnableAddOns = 'Enable add-ons selection for this category\n',
  DisableAddOns = 'None',
}

export enum ECategoryMealBuilderRole {
  Drink = 'drink',
  Side = 'side',
}

export enum ECategoryDrinkTemperature {
  Cold = 'cold',
  Hot = 'hot',
}

export enum ECategoryMealBuilderRoleText {
  Drink = 'Drinks',
  Side = 'Sides',
}

export enum ECategoryMealBuilderCategoryType {
  Side = 'side',
  ColdDrinks = 'cold',
  HotDrinks = 'hot',
}

export enum ECategoryMealBuilderCategoryTypeText {
  Side = 'Sides',
  ColdDrinks = 'Cold Drinks',
  HotDrinks = 'Hot Drinks',
}
